import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18nInstance from '../locales/i18n';
import { formatCurrency } from '../utils/formatters';
import {
Package, MapPin, ShoppingCart, Settings, Users, LayoutDashboard,
LogOut, ChevronDown, ChevronRight, Truck, Wallet, PlusCircle,
UserCircle, Search, Bell, FileText, BarChart3, ShieldCheck, PackageCheck,
TrendingUp, Activity, CreditCard, ClipboardCheck, RefreshCcw, ClipboardList,
Loader2, Cloud, User, History, UserCheck, UserRound, UploadCloud, PieChart, FileSpreadsheet,
Calendar,
Edit3,
BookOpen,
Book,
Lock,
Unlock, Grid,
X, Eye, EyeOff, Languages, Coins, Layers,
ArrowRightLeft,
Zap,
Bed,
UserCheck2,
Building2,
GraduationCap, BookMarked, Award, FileSpreadsheet as ReportIcon,
Utensils // 🚀 AJOUTÉ ICI POUR CORRIGER L'ERREUR
} from 'lucide-react';
import API from '../services/api';
import './Dashboard.css';
// -------------------------------------------------------------
// TOUS LES RACCOURCIS ONT DES ID UNIQUES
// -------------------------------------------------------------
const ALL_POSSIBLE_SHORTCUTS = [
// SYSTEM
{ id: 'params_cloud_push', label: 'Sauv. Cloud', path: '/params/sync', icon: <Cloud />, color: 'branch', module: 'SYSTEM' },
{ id: 'params_cloud_restore', label: 'Restaur. Cloud', path: '/params/restore', icon: <RefreshCcw />, color: 'SYSTEM', module: 'SYSTEM' },
{ id: 'params_edit_settings', label: 'Paramètres', path: '/params/settings', icon: <Settings />, color: 'branch', module: 'SYSTEM' },
{ id: 'params_view_licence', label: 'Ma Licence', path: '/admin/licence', icon: <ShieldCheck />, color: 'branch', module: 'SYSTEM' },
{ id: 'params_view_audit', label: 'Journal d\'audit', path: '/audit', icon: <ShieldCheck />, color: 'branch', module: 'SYSTEM' },
// RAPPORTS MANAGER
{ id: 'rapport_ca', label: 'Rapport CA', path: '/rapports/ca', icon: <BarChart3 />, color: 'branch', module: 'SYSTEM' },
{ id: 'rapport_encaissement', label: 'Rapport Encaissement', path: '/rapports/encaissements', icon: <Wallet />, color: 'branch', module: 'SYSTEM' },
{ id: 'rapport_night_audit', label: 'Rapport Night Audit', path: '/rapports/night-audit', icon: <FileText />, color: 'pos', module: 'HEBERGEMENT' },
// SCOLAIRE
{ id: 'scol_cycles_manage', label: 'Cycles Pédagogiques', path: '/scolaire/cycles', icon: <GraduationCap />, color: 'pos', module: 'SCOOL' }, 
{ id: 'scol_annees_manage', label: 'Années Scolaires', path: '/scolaire/annees', icon: <Calendar />, color: 'pos', module: 'SCOOL' }, 
{ id: 'scol_decoupages_manage', label: 'Découpages et Périodes', path: '/scolaire/decoupages-periodes', icon: <Layers />, color: 'pos', module: 'SCOOL' }, // 👈 Ajouté ici
{ id: 'scol_niveaux_manage', label: 'Niveaux et Classes', path: '/scolaire/niveaux-classes', icon: <Building2 />, color: 'pos', module: 'SCOOL' }, 
{ id: 'scol_matieres_manage', label: 'Matières et Affectations', path: '/scolaire/matieres', icon: <BookOpen />, color: 'pos', module: 'SCOOL' }, 
{ id: 'scol_eleves_manage', label: 'Élèves et Tuteurs', path: '/scolaire/eleves', icon: <Users />, color: 'pos', module: 'SCOOL' }, 
{ id: 'scol_enseignants_manage', label: 'Enseignants', path: '/scolaire/enseignants', icon: <GraduationCap />, color: 'pos', module: 'SCOOL' },
// HEBERGEMENT
{ id: 'heb_categories', label: 'Catégories Chambres', path: '/hebergement/categories', icon: <Bed />, color: 'pos', module: 'HEBERGEMENT' },
{ id: 'heb_chambres', label: 'Chambres Physiques', path: '/hebergement/chambres', icon: <Bed />, color: 'pos', module: 'HEBERGEMENT' },
{ id: 'heb_composants', label: 'Prestations & Catalogue', path: '/hebergement/composants', icon: <Layers />, color: 'pos', module: 'HEBERGEMENT' },
{ id: 'heb_composition_cat', label: 'Checkout', path: '/hebergement/Checkout', icon: <Layers />, color: 'pos', module: 'HEBERGEMENT' },
{ id: 'heb_planning', label: 'Planning Séjours', path: '/hebergement/planning', icon: <Calendar />, color: 'pos', module: 'HEBERGEMENT' },
{ id: 'heb_nouvelle_res', label: 'Nouvelle Réservation', path: '/hebergement/nouvelle-reservation', icon: <PlusCircle />, color: 'pos', module: 'HEBERGEMENT' },
{ id: 'heb_historique_res', label: 'Historique Réservations', path: '/hebergement/historique-reservations', icon: <ClipboardList />, color: 'pos', module: 'HEBERGEMENT' },
{ id: 'heb_encaissements', label: 'Encaissements Séjours', path: '/hebergement/encaissements', icon: <CreditCard />, color: 'pos', module: 'HEBERGEMENT' },
{ id: 'heb_regles_tarifs', label: 'Règles Tarifs Horaires', path: '/hebergement/regles-tarifs', icon: <Settings />, color: 'pos', module: 'HEBERGEMENT' },
{ id: 'heb_checkin_checkout', label: 'Check-In / Check-Out', path: '/hebergement/checkin', icon: <UserCheck />, color: 'pos', module: 'HEBERGEMENT' },
{ id: 'heb_parametres_horaires', label: 'Paramètres Horaires', path: '/hebergement/parametres-horaires', icon: <Settings />, color: 'pos', module: 'HEBERGEMENT' },
{ id: 'heb_extras_config', label: 'Configuration Extras', path: '/hebergement/extras', icon: <Layers />, color: 'pos', module: 'HEBERGEMENT' },
{ id: 'heb_poster_extras', label: 'Guichet Vente Extras', path: '/hebergement/poster-extras', icon: <ShoppingCart />, color: 'pos', module: 'HEBERGEMENT' },
{ id: 'heb_historique_extras', label: 'Facturation & Hist. Extras', path: '/hebergement/historique-extras', icon: <FileText />, color: 'pos', module: 'HEBERGEMENT' },
{ id: 'heb_civilites', label: 'Civilités', path: '/hebergement/civilites', icon: <UserCheck2 />, color: 'pos', module: 'HEBERGEMENT' },
{ id: 'heb_societes', label: 'Gestion Sociétés', path: '/hebergement/societes', icon: <Building2 />, color: 'pos', module: 'HEBERGEMENT' },
// GESTOCK - POS (VENTES)
// Définition des éléments de navigation
{ id: 'pos_vente_create', label: 'Nouvelle Vente', path: '/pos', icon: <ShoppingCart />, color: 'pos', module: 'GESTOCK' },
{ id: 'pos_add', label: 'Ajouter Vente', path: '/pos/add', icon: <PlusCircle />, color: 'pos', module: 'GESTOCK' },
{ id: 'pos_validate', label: 'Valider Ventes', path: '/pos/validate', icon: <Search />, color: 'pos', module: 'GESTOCK' },
{ id: 'pos_invoice', label: 'Facture Client', path: '/pos/invoice', icon: <FileText />, color: 'pos', module: 'GESTOCK' },
{ id: 'pos_history', label: 'Hist. Ventes', path: '/pos/history', icon: <Search />, color: 'pos', module: 'GESTOCK' },
{ id: 'pos_creances_clients', label: 'Créances Clients', path: '/pos/creances-clients', icon: <Wallet/>, color: 'pos', module: 'GESTOCK' },
{ id: 'pos_details', label: 'Ventes Détaillées', path: '/pos-details', icon: <FileSpreadsheet />, color: 'pos', module: 'GESTOCK' },
{ id: 'pos_vente_grille', label: 'Commerciale', path: '/pos/commerciale-clients', icon: <FileSpreadsheet />, color: 'pos', module: 'GESTOCK' },
{ id: 'pos_vente_liste', label: 'Tournées Commerciales', path: '/pos/tourneesCommerciales-clients', icon: <FileSpreadsheet />, color: 'pos', module: 'GESTOCK' },
{ id: 'pos_restaurant_create', label: 'POS Restaurant', path: '/pos/restaurant', icon: <Utensils />, color: 'pos', module: 'PRODUCTION' },  
{ id: 'pos_restaurant_vsp_create', label: 'POS Restaurant (Sans Production)', path: '/pos/restaurant-sans-production', icon: <Utensils />, color: 'pos', module: 'PRODUCTION' },
// TIERS
{ id: 'tiers_fournisseur', label: 'Fournisseurs', path: '/Tiers/fournisseurs', icon: <Users />, color: 'system', module: 'SYSTEM' },
{ id: 'tiers_client', label: 'Clients', path: '/Tiers/clients', icon: <Users />, color: 'system', module: 'SYSTEM' },
// GESTION CAISSE & SYSTÈME (INDÉPENDANTS DU POS)
{ id: 'caisse_close', label: 'Clôture Caisse', path: '/pos/close', icon: <Lock />, color: 'pos', module: 'SYSTEM' },
{ id: 'caisse_history_cloture', label: 'Hist. Clôture', path: '/pos/historique-cloture', icon: <Search />, color: 'pos', module: 'SYSTEM' },
{ id: 'caisse_methodes', label: 'Méthodes Paiement', path: '/pos/paiements/methodes', icon: <Settings />, color: 'items', module: 'SYSTEM' },
// GESTOCK - LOGISTIQUE
{ id: 'log_buy', label: 'Faire Achat', path: '/logistique/achat', icon: <PlusCircle />, color: 'stock', module: 'GESTOCK' },
{ id: 'log_history', label: 'Hist. Achats', path: '/logistique/hist-achats', icon: <Search />, color: 'stock', module: 'GESTOCK' },
{ id: 'log_inventory', label: 'Faire Inventaire', path: '/logistique/inventaire', icon: <ClipboardCheck />, color: 'stock', module: 'GESTOCK' },
{ id: 'log_inventory_hist', label: 'Hist. Inventaire', path: '/logistique/historique-inventaire', icon: <History />, color: 'stock', module: 'GESTOCK' },
{ id: 'log_suppliers_dettes', label: 'Dettes Fournisseurs', path: '/logistique/dettes-fournisseurs', icon: <Truck />, color: 'stock', module: 'GESTOCK' },
{ id: 'log_ajustement', label: 'Pertes & Avaries', path: '/logistique/ajustements', icon: <ArrowRightLeft />, color: 'stock', module: 'GESTOCK' },
{ id: 'log_historique_ajustement', label: 'Historique Pertes', path: '/logistique/historique-ajustements', icon: <ClipboardList />, color: 'stock', module: 'GESTOCK' },
{ id: 'log_bon_commande', label: 'Passer Commande', path: '/logistique/bon-commande', icon: <ShoppingCart />, color: 'stock', module: 'GESTOCK' },
{ id: 'log_historique_bon', label: 'Historique Bons', path: '/logistique/historique-bon', icon: <ClipboardList />, color: 'stock', module: 'GESTOCK' },
// GESTOCK - ARTICLES
{ id: 'art_view', label: 'Catalogue', path: '/articles', icon: <Package />, color: 'items', module: 'GESTOCK' },
{ id: 'art_create', label: 'Ajouter Article', path: '/articles/create', icon: <PlusCircle />, color: 'items', module: 'GESTOCK' },
{ id: 'art_mod', label: 'Ajouter Article', path: '/articles', icon: <PlusCircle />, color: 'items', module: 'GESTOCK' },
{ id: 'art_list', label: 'Liste Produits', path: '/articles/list', icon: <PlusCircle />, color: 'items', module: 'GESTOCK' },
{ id: 'art_categories', label: 'Catégories', path: '/articles/categories', icon: <Settings />, color: 'items', module: 'GESTOCK' },
{ id: 'art_edit', label: 'Modifier Art.', path: '/articles/edit', icon: <Package />, color: 'items', module: 'GESTOCK' },
{ id: 'art_gl', label: 'Grand Livre Art.', path: '/articles/history', icon: <Package />, color: 'items', module: 'GESTOCK' },
{ id: 'art_tables', label: 'Gestion des Tables', path: '/articles/tables', icon: <Grid />, color: 'items', module: 'GESTOCK' },
// GESTOCK - EMBALLAGES
{ id: 'emb_achat', label: 'Achat Emballages', path: '/emballage/achat', icon: <Layers />, color: 'items', module: 'EMBALLAGE' },
{ id: 'emb_history', label: 'Hist. Flux Embal.', path: '/emballage/historique-flux-emballage', icon: <History />, color: 'pos', module: 'EMBALLAGE' },
{ id: 'emb_regles', label: 'Regles Consignation', path: '/emballage/regles-consignation', icon: <Settings />, color: 'items', module: 'EMBALLAGE' },
{ id: 'emb_create', label: 'Créer Emballages', path: '/emballage/create', icon: <PlusCircle />, color: 'items', module: 'EMBALLAGE' },
{ id: 'emb_inventory_suivi', label: 'Suivi Inv. Emballages', path: '/emballages/suivi', icon: <ClipboardList />, color: 'logistique', module: 'EMBALLAGE' },
{ id: 'emb_inventory_saisie', label: 'Saisie Inv. Emballages', path: '/emballages/inventaire/saisie', icon: <PackageCheck />, color: 'logistique', module: 'EMBALLAGE' },
{ id: 'emb_consignation', label: 'Consignation Emballages', path: '/emballages/consignation', icon: <ArrowRightLeft />, color: 'pos', module: 'EMBALLAGE' },
// COMPTA BASE
{ id: 'compta_treso_ventilation', label: 'Ventilation Tréso', path: '/compta/treso/ventilation', icon: <ArrowRightLeft />, color: 'items', module: 'COMPTA_BASE' },
{ id: 'compta_ex', label: 'Exercice Fiscal', path: '/compta/exercices', icon: <Calendar />, color: 'items', module: 'COMPTA_BASE' },
{ id: 'compta_jr', label: 'Codes Journaux', path: '/compta/journaux', icon: <Settings />, color: 'items', module: 'COMPTA_BASE' },
{ id: 'compta_plan', label: 'Plan Comptable', path: '/compta/plan', icon: <FileText />, color: 'items', module: 'COMPTA_BASE' },
{ id: 'compta_tiers', label: 'Plan des Tiers', path: '/compta/tiers', icon: <UserCheck />, color: 'items', module: 'COMPTA_BASE' },
{ id: 'compta_brouillard_config', label: 'Config. Brouillards', path: '/compta/type-brouillards', icon: <Settings />, color: 'items', module: 'COMPTA_BASE' },
{ id: 'compta_ecritures_auto', label: 'Param. Écritures Auto', path: '/compta/config-ecritures-auto', icon: <Settings />, color: 'items', module: 'COMPTA_BASE' },
{ id: 'compta_cloture', label: 'Clôture Journalière', path: '/compta/cloture-journaliere', icon: <Lock />, color: 'branch', module: 'COMPTA_BASE' },
{ id: 'analytique_plan', label: 'Plan Analytique', path: '/analytique/plan', icon: <PieChart />, color: 'branch', module: 'COMPTA_BASE' },
{ id: 'compta_treso_saisie_hub', label: 'Saisie Trésorerie', path: '/compta/treso/choix-brouillard', icon: <Wallet />, color: 'pos', module: 'COMPTA_BASE' },
{ id: 'compta_treso_val', label: 'Validation Trésorerie', path: '/compta/treso/validation', icon: <ShieldCheck />, color: 'pos', module: 'COMPTA_BASE' },
{ id: 'compta_brouillon', label: 'Saisie Assistant', path: '/compta/brouillon-selection', icon: <Edit3 />, color: 'pos', module: 'COMPTA_BASE' },
{ id: 'compta_val', label: 'Valider Brouillons', path: '/compta/validation', icon: <ClipboardCheck />, color: 'pos', module: 'COMPTA_BASE' },
{ id: 'compta_gen', label: 'Saisie Journal', path: '/compta/gen', icon: <Edit3 />, color: 'items', module: 'COMPTA_BASE' },
{ id: 'compta_treso_cash', label: 'Caisse/Banques', path: '/compta/caisse', icon: <Wallet />, color: 'stock', module: 'COMPTA_BASE' },
{ id: 'compta_factures', label: 'Factures/Règl.', path: '/compta/factures', icon: <ShoppingCart />, color: 'items', module: 'COMPTA_BASE' },
{ id: 'compta_rpt_gl_comptes', label: 'Grand Livre G.', path: '/compta/rapports/grand-livre', icon: <Book />, color: 'items', module: 'COMPTA_BASE' },
{ id: 'compta_clients', label: 'Comptes Clients', path: '/compta/clients', icon: <Users />, color: 'items', module: 'COMPTA_BASE' },
{ id: 'compta_rpt_bilan', label: 'Bilan / Résultat', path: '/compta/rapports/bilan', icon: <LayoutDashboard />, color: 'items', module: 'COMPTA_BASE' },
{ id: 'compta_marge', label: 'Analyse Marge', path: '/compta/marge', icon: <TrendingUp />, color: 'pos', module: 'COMPTA_BASE' },
{ id: 'compta_audit', label: 'Validation / Audit', path: '/compta/audit', icon: <ShieldCheck />, color: 'branch', module: 'COMPTA_BASE' },
{ id: 'compta_rpt_gl_tiers', label: 'Grand Livre Tiers', path: '/compta/rapports/grand-livre-tiers', icon: <Users />, color: 'items', module: 'COMPTA_BASE' },
{ id: 'compta_rpt_bal_tiers', label: 'Balance Tiers', path: '/compta/rapports/balance-tiers', icon: <Users />, color: 'items', module: 'COMPTA_BASE' },
{ id: 'compta_etats_recap', label: 'États Financiers', path: '/compta/rapports/etats-financiers', icon: <LayoutDashboard />, color: 'items', module: 'COMPTA_BASE' },
{ id: 'compta_rpt_central', label: 'Journal Centralisateur', path: '/compta/rapports/central', icon: <BookOpen />, color: 'items', module: 'COMPTA_BASE' },
// rapports manager
{ id: 'rapports_ca', label: 'Rapport CA', path: '/rapports/ca', icon: <BarChart3 />, color: 'branch', module: 'SYSTEM' },
{ id: 'rapports_encaissement', label: 'Rapport Encaissement', path: '/rapports/encaissements', icon: <Wallet />, color: 'branch', module: 'SYSTEM' },
{ id: 'rapports_night_audit', label: 'Rapport Night Audit', path: '/rapports/night-audit', icon: <FileText />, color: 'pos', module: 'HEBERGEMENT' },
// PRODUCTION & ANALYTIQUE
{ id: 'analytique_dept', label: 'Centres de Coûts', path: '/analytique/departements', icon: <MapPin />, color: 'branch', module: 'PRODUCTION' },
{ id: 'analytique_charges', label: 'Gestion Charges', path: '/analytique/charges', icon: <Wallet />, color: 'items' , module: 'PRODUCTION' },
{ id: 'analytique_mp', label: 'Matières Premières', path: '/analytique/mp/liste', icon: <Package />, color: 'stock', module: 'PRODUCTION' },
{ id: 'analytique_ft', label: 'Fiches Techniques', path: '/analytique/ft/creation', icon: <ClipboardCheck />, color: 'items' , module: 'PRODUCTION' },
{ id: 'prod_besoin', label: 'Émettre Besoin', path: '/analytique/production/besoin', icon: <PlusCircle />, color: 'pos', module: 'PRODUCTION' },
{ id: 'prod_enregistrer_commande', label: 'Prod. & Commande', path: '/analytique/production/enregistrer-commande', icon: <Zap />, color: 'pos', module: 'PRODUCTION' },
{ id: 'prod_magasin_verif', label: 'Vérif. Magasin', path: '/analytique/production/magasin', icon: <Search />, color: 'stock', module: 'PRODUCTION' },
{ id: 'prod_pilotage', label: 'Lancer Prod.', path: '/analytique/production/pilotage', icon: <Activity />, color: 'pos' , module: 'PRODUCTION' },
{ id: 'prod_magasin_reception', label: 'Magasinage & Réception', path: '/analytique/production/reception', icon: <PackageCheck />, color: 'stock', module: 'PRODUCTION' },
{ id: 'prod_regularisations', label: 'Régul. Stocks Attente', path: '/analytique/production/regularisations-attente', icon: <ArrowRightLeft />, color: 'stock', module: 'PRODUCTION' },
{ id: 'analytique_psf_hist', label: 'Hist. Prod (PSF)', path: '/analytique/psf/historique', icon: <History />, color: 'pos' , module: 'PRODUCTION' },
{ id: 'analytique_prod_hist', label: 'Hist. Production', path: '/analytique/production', icon: <History />, color: 'pos' , module: 'PRODUCTION' },
{ id: 'analytique_mp_categories', label: 'Catégories MP', path: '/analytique/mp/categories', icon: <Layers />, color: 'stock', module: 'PRODUCTION' },
{ id: 'prod_magasin_hist_conso', label: 'Hist. Consommations', path: '/analytique/production/historique-consommations', icon: <History />, color: 'stock', module: 'PRODUCTION' },
{ id: 'analytique_mp_inventaire', label: 'Inventaire MP', path: '/analytique/mp/inventaire', icon: <ClipboardCheck />, color: 'stock', module: 'PRODUCTION' },
{ id: 'analytique_psf_inventaire', label: 'Inventaire PSF', path: '/analytique/psf/inventaire', icon: <ClipboardCheck />, color: 'stock', module: 'PRODUCTION' },
{ id: 'prod_sur_mesure', label: 'Vente Sur-Mesure', path: '/analytique/production/sur-mesure', icon: <ShoppingCart />, color: 'pos', module: 'PRODUCTION' },
{ id: 'prod_conso_dep', label: 'Consommation Directe', path: '/analytique/production/consommation-departement', icon: <ShoppingCart />, color: 'pos', module: 'PRODUCTION' },
{ id: 'prod_conso_dep_hist', label: 'Hist. Conso. Départements', path: '/analytique/production/consommation-departement-historique', icon: <History />, color: 'stock', module: 'PRODUCTION' },
// RH & USERS
{ id: 'staff_manage', label: 'Gestion Staff', path: '/staff', icon: <UserRound />, color: 'branch', module: 'SYSTEM' },
{ id: 'user_create', label: 'Comptes User', path: '/users', icon: <ShieldCheck />, color: 'branch', module: 'SYSTEM' }
];

const NavDropdown = ({ id, label, icon: Icon, children, level = 0, openMenus, toggleMenu }) => {
const isOpen = openMenus[id];
return (
<div className={`nav-dropdown-group level-${level}`}>
<button className={`nav-item ${isOpen ? 'is-open' : ''}`} onClick={() => toggleMenu(id)}>
<div className="nav-item-content">
{Icon && <Icon size={20} />}
<span>{label}</span>
</div>
{isOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
</button>
{isOpen && <div className="nav-submenu">{children}</div>}
</div>
);
};

const Dashboard = () => {
const navigate = useNavigate();
const { t } = useTranslation();

const [licenseData, setLicenseData] = useState(() => {
try {
const rawStatus = localStorage.getItem('licenseStatus') || '{}';
const parsed = JSON.parse(rawStatus);
let mods = parsed.allowed_modules || [];
if (typeof mods === 'string') {
  try {
    mods = JSON.parse(mods);
  } catch (e) {
    mods = mods.replace(/[\[\]"']/g, '').split(',').map(m => m.trim().toUpperCase());
  }
}
if (Array.isArray(mods)) {
  mods = mods.map(m => String(m).replace(/[\[\]"']/g, '').trim().toUpperCase());
} else {
  mods = [];
}
return { allowed_modules: mods, valid: parsed.valid ?? true };
} catch (e) {
return { allowed_modules: [], valid: false };
}
});

const user = JSON.parse(localStorage.getItem('user') || '{}');
const userRole = (user.role || '').toLowerCase();
const companyName = localStorage.getItem('companyName') || 'Ledi Expert Pro';
const companyId = localStorage.getItem('companyId');
const isAdmin = userRole === 'admin' || userRole === 'super_admin';
const [currency, setCurrency] = useState(() => localStorage.getItem('erp_currency') || 'XOF');
const [showStats, setShowStats] = useState(false);
const [alertMsg, setAlertMsg] = useState({ text: '', type: '' });
const [searchTerm, setSearchTerm] = useState("");
const [isSearchFocused, setIsSearchFocused] = useState(false);
const [selectedBranchId, setSelectedBranchId] = useState(() => localStorage.getItem('admin_selected_branch') || (isAdmin ? 'all' : user.branchId));
const [branches, setBranches] = useState([]);
const [openMenus, setOpenMenus] = useState({});
const [isLoading, setIsLoading] = useState(true);
const [isRestoring, setIsRestoring] = useState(false);
const [isPushing, setIsPushing] = useState(false);
const [isEditingShortcuts, setIsEditingShortcuts] = useState(false);
const [stats, setStats] = useState({
totalProducts: 0, stockAlerts: 0, dailySales: 0, totalAvoirs: 0,
bankBalance: 0, cashBalance: 0, supplierDebt: 0, customerCredit: 0,
totalChambres: 0, chambresDisponibles: 0, chambresOccupees: 0,
departsAttendus: 0, arriveesPrevues: 0
});

const [myShortcuts, setMyShortcuts] = useState(() => {
const saved = localStorage.getItem(`fav_shortcuts_${user.id}`);
return saved ? JSON.parse(saved) : ['heb_planning', 'pos_vente_create', 'log_buy', 'art_view', 'rapport_ca'];
});

useEffect(() => {
const checkLiveLicenseAndFetchData = async () => {
if (!companyId) return;
setIsLoading(true);
try {
const [licenseRes, statsRes] = await Promise.all([
API.get(`/license/status?t=${Date.now()}`).catch(() => null),
API.get('/dashboard/stats')
]);
    if (licenseRes && licenseRes.data) {
      let mods = licenseRes.data.allowed_modules || [];
      if (typeof mods === 'string') {
        try {
          mods = JSON.parse(mods);
        } catch (e) {
          mods = mods.replace(/[\[\]"']/g, '').split(',').map(m => m.trim().toUpperCase());
        }
      }
      if (Array.isArray(mods)) {
        mods = mods.map(m => String(m).replace(/[\[\]"']/g, '').trim().toUpperCase());
      } else {
        mods = [];
      }

      const liveStatus = { 
        allowed_modules: mods, 
        valid: licenseRes.data.valid ?? false,
        nom: licenseRes.data.nom,
        exp: licenseRes.data.exp
      };
      setLicenseData(liveStatus);
      localStorage.setItem('licenseStatus', JSON.stringify(liveStatus));
      if (licenseRes.data.nom) localStorage.setItem('companyName', licenseRes.data.nom);
    }

    if (statsRes && statsRes.data) setStats(statsRes.data);
  } catch (err) {
    console.error("Erreur API:", err.response?.data?.error || err.message);
  } finally {
    setIsLoading(false);
  }
};
checkLiveLicenseAndFetchData();
}, [companyId]);

// ==========================================
// ARCHITECTURE DE PERMISSIONS ET LICENCES
// ==========================================
const canAccessModule = useCallback((moduleKey) => {
if (!moduleKey) return true;
const targetModule = String(moduleKey).toUpperCase();
if (targetModule === 'SYSTEM') return true;

return licenseData.allowed_modules.includes(targetModule) || 
       licenseData.allowed_modules.includes('FULL_ACCESS');
}, [licenseData.allowed_modules]);

const hasPermission = useCallback((permissionKey) => {
if (isAdmin) return true;
if (!permissionKey) return false;
let perms = user.permissions;
while (typeof perms === 'string' && perms.trim() !== "") {
  try { perms = JSON.parse(perms); } catch (e) { return false; }
}
if (!perms || typeof perms !== 'object') return false;

const value = perms[permissionKey];
return value === true || value === 1 || value === 'true' || value === '1';
}, [isAdmin, user.permissions]);

const hasAnyPermission = useCallback((permissionsArray) => {
return permissionsArray.some(p => hasPermission(p));
}, [hasPermission]);

const showToast = (text, type = 'success') => {
setAlertMsg({ text, type });
setTimeout(() => setAlertMsg({ text: '', type: '' }), 3000);
};

const switchLanguage = (langCode) => i18nInstance.changeLanguage(langCode);

const switchCurrency = (currencyCode) => {
setCurrency(currencyCode);
localStorage.setItem('erp_currency', currencyCode);
window.dispatchEvent(new Event('storage'));
};

const toggleMenu = (menuId) => {
setOpenMenus(prev => {
const isCurrentlyOpen = !!prev[menuId];
const topLevelIds = ['params', 'access_hebergement', 'access_scolaire', 'pos', 'gestion_caisse', 'logistique', 'access_articles', 'access_emballages', 'rh_management', 'tiers', 'compta', 'access_analytique', 'rapports_manager'];
const comptaSubIds = ['compta_gen_group', 'tresorerie_group', 'compta_rapports_group'];
  let newOpenMenus = { ...prev };

  if (topLevelIds.includes(menuId)) {
    topLevelIds.forEach(id => {
      if (id !== menuId) {
        newOpenMenus[id] = false;
        if (id === 'compta') comptaSubIds.forEach(subId => { newOpenMenus[subId] = false; });
      }
    });
    newOpenMenus[menuId] = !isCurrentlyOpen;
  } else if (comptaSubIds.includes(menuId)) {
    comptaSubIds.forEach(id => {
      if (id !== menuId) newOpenMenus[id] = false;
    });
    newOpenMenus[menuId] = !isCurrentlyOpen;
  } else {
    newOpenMenus[menuId] = !isCurrentlyOpen;
  }
  return newOpenMenus;
});
};

const smartNavigate = (path) => {
    if (path.startsWith('/admin') || path.startsWith('/scolaire') ||path.startsWith('/hebergement') ||path.startsWith('/articles') || path.startsWith('/rapports') || path.startsWith('/logistique') || path.startsWith('/pos') || path.startsWith('/rh') || path.startsWith('/analytique') || path.startsWith('/compta') || path.startsWith('/emballage') || path.startsWith('/Tiers')) {
        navigate(path);
    } else {
        navigate(`/admin${path.startsWith('/') ? path : '/' + path}`);
    }
};

const searchResults = useMemo(() => {
if (!searchTerm.trim()) return [];
const query = searchTerm.toLowerCase();
return ALL_POSSIBLE_SHORTCUTS.filter(action => {
const isAccessible = canAccessModule(action.module) && hasPermission(action.id);
return isAccessible && action.label.toLowerCase().includes(query);
}).map(p => ({ ...p, type: 'page' }));
}, [searchTerm, canAccessModule, hasPermission]);

const handleManualPush = async () => {
if (isAdmin && selectedBranchId === 'all') {
alert(t('dashboard.alerts.select_branch', "❌ Sélectionnez une entité précise.")); return;
}
const branchIdToUse = isAdmin ? selectedBranchId : user.branchId;
if (!window.confirm(t('dashboard.alerts.confirm_backup', "☁️ Sauvegarder vers le Cloud ?"))) return;
setIsPushing(true);
try {
const response = await API.post('/sync/restore-to-cloud', { companyId, branchId: branchIdToUse });
if (response.data.success) alert(t('dashboard.alerts.backup_success', "✅ Réussi !"));
} catch (err) { alert(t('dashboard.alerts.backup_error', "❌ Erreur lors de la sauvegarde.")); }
finally { setIsPushing(false); }
};

const handleCloudRestore = async () => {
if (!window.confirm(t('dashboard.alerts.confirm_restore', "⚠ Écraser les données locales par celles du Cloud ?"))) return;
setIsRestoring(true);
try {
const response = await API.post('/sync/restore', { companyId, userRole });
if (response.data.success) {
alert(t('dashboard.alerts.restore_success', "Restauration terminée !"));
window.location.reload();
}
} catch (err) { alert(t('dashboard.alerts.restore_error', "Erreur lors de la restauration.")); }
finally { setIsRestoring(false); }
};

const handleSaveShortcuts = () => {
localStorage.setItem(`fav_shortcuts_${user.id}`, JSON.stringify(myShortcuts));
setIsEditingShortcuts(false);
showToast(t('dashboard.alerts.shortcuts_updated', "Raccourcis mis à jour !"));
};

return (
<div className="dashboard-layout">
<aside className="sidebar">
<div className="sidebar-header">
<div className="logo-m">{companyName.charAt(0).toUpperCase()}</div>
<div className="company-info">
<span className="company-name">{companyName}</span>
<span
className="status-badge"
style={{
backgroundColor: licenseData?.valid ? '#10b981' : '#ef4444',
color: '#ffffff', padding: '2px 8px', borderRadius: '12px',
fontSize: '11px', fontWeight: '700', marginTop: '4px',
display: 'inline-block', textAlign: 'center'
}}
>
{licenseData?.valid ? t('dashboard.licence.active', 'Licence Active') : t('dashboard.licence.invalid', 'Licence Invalide')}
</span>
</div>
</div>
    <nav className="sidebar-nav">
      <button className="nav-item active" onClick={() => navigate('/admin/dashboard')}>
        <div className="nav-item-content">
          <LayoutDashboard size={20}/> 
          <span>{t('sidebar.dashboard', 'Dashboard')}</span>
        </div>
      </button>

      {canAccessModule('SYSTEM') && hasAnyPermission(['params_edit_settings', 'params_view_licence', 'params_view_audit', 'params_cloud_push', 'params_cloud_restore']) && (
        <NavDropdown id="params" label={t('sidebar.company_settings', 'Paramètres Société')} icon={Settings} openMenus={openMenus} toggleMenu={toggleMenu}>
          {hasPermission('params_edit_settings') && <button className="sub-item" onClick={() => smartNavigate('/settings')}>{t('sidebar.company_info', 'Informations de la Société')}</button>}
          {hasPermission('params_view_licence') && <button className="sub-item" onClick={() => smartNavigate('/admin/licence')}>{t('sidebar.my_license', 'Ma licence')}</button>}
          {hasPermission('params_view_audit') && <button className="sub-item" onClick={() => navigate('/audit')}><Activity size={14} style={{ marginRight: '8px' }}/>{t('sidebar.audit_log', 'Journal des actions')}</button>}
          {hasPermission('params_cloud_push') && (
            <button className="sub-item" onClick={handleManualPush} disabled={isPushing} style={{ color: '#2563eb', fontWeight: 'bold' }}>
              {isPushing ? <Loader2 size={14} className="animate-spin" /> : <UploadCloud size={14} />}<span style={{ marginLeft: '8px' }}>{t('sidebar.cloud_backup', 'Sauvegarder vers Cloud')}</span>
            </button>
          )}
          {hasPermission('params_cloud_restore') && (
            <button className="sub-item" onClick={handleCloudRestore} disabled={isRestoring} style={{ color: '#c2410c', fontWeight: 'bold' }}>
              {isRestoring ? <Loader2 size={14} className="animate-spin" /> : <RefreshCcw size={14} />}<span style={{ marginLeft: '8px' }}>{t('sidebar.cloud_restore', 'Restauration Cloud')}</span>
            </button>
          )}
          <hr style={{ border: '0.1px solid #334155', margin: '4px 0' }} />
        </NavDropdown>
      )}

{canAccessModule('SCOOL') && hasAnyPermission(['scol_cycles_manage', 'scol_annees_manage', 'scol_decoupages_manage', 'scol_niveaux_manage', 'scol_matieres_manage', 'scol_eleves_manage', 'scol_enseignants_manage']) && (
    <NavDropdown id="access_scolaire" label="Gestion Scolaire" icon={GraduationCap} openMenus={openMenus} toggleMenu={toggleMenu}>
      {hasPermission('scol_annees_manage') && <button className="sub-item" onClick={() => smartNavigate('/scolaire/annees')}>Années Scolaires</button>}
      {hasPermission('scol_cycles_manage') && <button className="sub-item" onClick={() => smartNavigate('/scolaire/cycles')}>Cycles Pédagogiques</button>}
      {hasPermission('scol_decoupages_manage') && <button className="sub-item" onClick={() => smartNavigate('/scolaire/decoupages-periodes')}>Découpages et Périodes</button>} {/* 👈 Ajouté ici */}
      {hasPermission('scol_niveaux_manage') && <button className="sub-item" onClick={() => smartNavigate('/scolaire/niveaux-classes')}>Niveaux et Classes</button>}
      {hasPermission('scol_matieres_manage') && <button className="sub-item" onClick={() => smartNavigate('/scolaire/matieres')}>Matières & Affectations</button>}
      {hasPermission('scol_eleves_manage') && <button className="sub-item" onClick={() => smartNavigate('/scolaire/eleves')}>Élèves et Tuteurs</button>}
      {hasPermission('scol_enseignants_manage') && <button className="sub-item" onClick={() => smartNavigate('/scolaire/enseignants')}>Enseignants</button>}
      <hr style={{ border: '0.1px solid #334155', margin: '4px 0' }} />
    </NavDropdown>
)}




{canAccessModule('HEBERGEMENT') && hasAnyPermission([
  'heb_categories', 'heb_chambres', 'heb_composants', 'heb_composition_cat', 
  'heb_planning', 'heb_nouvelle_res', 'heb_historique_res', 'heb_encaissements', 
  'heb_checkin_checkout', 'heb_regles_tarifs', 'heb_parametres_horaires',
  'heb_extras_config', 'heb_poster_extras', 'heb_historique_extras' // 👈 Ajouté ici
]) && (
  <NavDropdown id="access_hebergement" label="Hébergement & Hôtel" icon={Bed} openMenus={openMenus} toggleMenu={toggleMenu}>
    {hasPermission('heb_planning') && <button className="sub-item" onClick={() => smartNavigate('/hebergement/planning')}>Planning & Séjours</button>}
    {hasPermission('heb_nouvelle_res') && <button className="sub-item" onClick={() => smartNavigate('/hebergement/nouvelle-reservation')}>Nouvelle Réservation</button>}
    {hasPermission('heb_historique_res') && <button className="sub-item" onClick={() => smartNavigate('/hebergement/historique-reservations')}>Historique Réservations</button>}
    {hasPermission('heb_checkin_checkout') && <button className="sub-item" onClick={() => smartNavigate('/hebergement/checkin')}>Check-in Walkin</button>}
    {hasPermission('heb_composition_cat') && <button className="sub-item" onClick={() => smartNavigate('/hebergement/Checkout')}>Checkout</button>}
    
    
    {hasPermission('heb_extras_config') && <button className="sub-item" onClick={() => smartNavigate('/hebergement/extras')}>Configuration des Extras</button>}
    {hasPermission('heb_extras_guichet') && <button className="sub-item" onClick={() => smartNavigate('/hebergement/poster-extras')}>Guichet Vente Extras</button>}
    {hasPermission('heb_extras_historique') && <button className="sub-item" onClick={() => smartNavigate('/hebergement/historique-extras')}>Historique Extras</button>}
    
    {hasPermission('heb_encaissements') && <button className="sub-item" onClick={() => smartNavigate('/hebergement/encaissements')}>Encaissements & Règlements</button>}

    
    {hasPermission('heb_categories') && <button className="sub-item" onClick={() => smartNavigate('/hebergement/categories')}>Catégories Chambres</button>}
    {hasPermission('heb_composants') && <button className="sub-item" onClick={() => smartNavigate('/hebergement/composants')}>Prestations</button>}
    {hasPermission('heb_chambres') && <button className="sub-item" onClick={() => smartNavigate('/hebergement/chambres')}>Chambres Physiques</button>}
    {hasPermission('heb_regles_tarifs') && <button className="sub-item" onClick={() => smartNavigate('/hebergement/regles-tarifs')}>Règles Tarifs Horaires</button>} 
    {hasPermission('heb_parametres_horaires') && <button className="sub-item" onClick={() => smartNavigate('/hebergement/parametres-horaires')}>Paramètres Horaires & No-Show</button>}
    {hasPermission('heb_chambres') && <button className="sub-item" onClick={() => smartNavigate('/hebergement/civilites')}>Civilités</button>}
    {hasPermission('heb_chambres') && <button className="sub-item" onClick={() => smartNavigate('/hebergement/societes')}>Gestion Sociétés</button>}
    <hr style={{ border: '0.1px solid #334155', margin: '4px 0' }} />
  </NavDropdown>
)}
{canAccessModule('GESTOCK') && hasAnyPermission(['pos_vente_create', 'pos_add', 'pos_validate', 'pos_invoice', 'pos_history', 'caisse_close', 'caisse_history_cloture', 'caisse_methodes', 'vente_view', 'pos_creances_clients', 'pos_details', 'pos_vente_grille', 'pos_vente_liste', 'pos_restaurant', 'pos_restaurant_vsp']) && (
    <NavDropdown id="pos" label={t('sidebar.pos_terminal', 'Terminal de Vente POS')} icon={ShoppingCart} openMenus={openMenus} toggleMenu={toggleMenu}>
      {hasPermission('pos_vente_create') && <button className="sub-item" onClick={() => smartNavigate('/pos')}>{t('sidebar.counter_sale', 'Vente au Comptoir')}</button>}
      {hasPermission('pos_add') && <button className="sub-item" onClick={() => smartNavigate('/pos/add')}>{t('sidebar.cart_sale', 'Vente Au panier')}</button>}
      {hasPermission('pos_validate') && <button className="sub-item" onClick={() => smartNavigate('/pos/validate')}>{t('sidebar.validate_cart', 'Valider un Panier')}</button>}
      
      {/* 🚀 1. POS RESTAURANT (AVEC PRODUCTION) */}
      {hasPermission('pos_restaurant_create') && (
          <button className="sub-item" onClick={() => smartNavigate('/pos/restaurant')} style={{ color: '#38bdf8', fontWeight: 'bold' }}>
              {t('sidebar.pos_restaurant', 'POS Restaurant & menus')}
          </button>
      )}

      {/* 🚀 2. POS RESTAURANT (SANS PRODUCTION / VSP) */}
      {hasPermission('pos_restaurant_vsp_create') && (
          <button className="sub-item" onClick={() => smartNavigate('/pos/restaurant-vsp')} style={{ color: '#34d399', fontWeight: 'bold' }}>
              {t('sidebar.pos_restaurant_vsp', 'POS Restaurant')}
          </button>
      )}

      {hasPermission('pos_invoice') && <button className="sub-item" onClick={() => smartNavigate('/pos/invoice')}>{t('sidebar.standardized_invoice', 'Vente Normalisée')}</button>}
      {hasPermission('pos_vente_grille') && <button className="sub-item" onClick={() => smartNavigate('/pos/commerciale-clients')}>{t('sidebar.standardized_grille', 'Commerciale')}</button>}
      {hasPermission('pos_vente_liste') && <button className="sub-item" onClick={() => smartNavigate('/pos/tourneesCommerciales-clients')}>{t('sidebar.standardized_tournees', 'Liste Commerciale')}</button>}
      {hasPermission('pos_history') && <button className="sub-item" onClick={() => smartNavigate('/pos/history')}>{t('sidebar.sales_history', 'Historique des ventes')}</button>}
      {hasPermission('pos_details') && <button className="sub-item" onClick={() => smartNavigate('/pos-details')}>{t('sidebar.detailed_sales', 'Rapports des ventes')}</button>}
      {hasPermission('pos_creances_clients') && <button className="sub-item" onClick={() => smartNavigate('/pos/creances-clients')}>{t('sidebar.customer_debts', 'Suivi Créances Clients')}</button>}
      <hr style={{ border: '0.1px solid #334155', margin: '4px 0' }} />
    </NavDropdown>
)}

      {canAccessModule('SYSTEM') && hasAnyPermission(['caisse_close', 'caisse_history_cloture', 'caisse_methodes']) && (
        <NavDropdown id="gestion_caisse" label={t('sidebar.caisse', 'Gestion caisse')} icon={Wallet} openMenus={openMenus} toggleMenu={toggleMenu}>
          {hasPermission('caisse_close') && <button className="sub-item" onClick={() => smartNavigate('/pos/close')}>{t('sidebar.shift_closing', 'Clôture de la Vente')}</button>}
          {hasPermission('caisse_history_cloture') && <button className="sub-item" onClick={() => smartNavigate('/pos/historique-cloture')}>{t('sidebar.closing_history', 'Historique des clôtures')}</button>}
          {hasPermission('caisse_methodes') && <button className="sub-item" onClick={() => navigate('/pos/paiements/methodes')}>{t('sidebar.add_payment_method', 'Ajouter un Moyen de Paiement')}</button>}
          <hr style={{ border: '0.1px solid #334155', margin: '4px 0' }} />
        </NavDropdown>
      )}

      {canAccessModule('GESTOCK') && hasAnyPermission(['log_suppliers', 'log_buy', 'log_history', 'log_inventory', 'log_inventory_hist', 'log_bon_commande', 'log_historique_bon', 'log_ajustement', 'log_historique_ajustement', 'log_suppliers_dettes']) && (
        <NavDropdown id="logistique" label={t('sidebar.purchasing_logistics', 'Achat & Logistique')} icon={Truck} openMenus={openMenus} toggleMenu={toggleMenu}>
          {hasPermission('log_buy') && <button className="sub-item" onClick={() => smartNavigate('/logistique/achat')}>{t('sidebar.make_purchase', 'Effectuer un Achat')}</button>}
          {hasPermission('log_history') && <button className="sub-item" onClick={() => smartNavigate('/logistique/hist-achats')}>{t('sidebar.purchase_history', 'Historique des achats')}</button>}
          {hasPermission('log_inventory') && <button className="sub-item" onClick={() => smartNavigate('/logistique/inventaire')}>{t('sidebar.inventory', 'Inventaire')}</button>}
          {hasPermission('log_inventory_hist') && <button className="sub-item" onClick={() => smartNavigate('/logistique/historique-inventaire')}>{t('sidebar.inventory_history', 'Historique Inventaires')}</button>}
          {hasPermission('log_bon_commande') && <button className="sub-item" onClick={() => smartNavigate('/logistique/bon-commande')}>{t('sidebar.make_order', 'Passer une Commande')}</button>}
          {hasPermission('log_historique_bon') && <button className="sub-item" onClick={() => smartNavigate('/logistique/historique-bon')}>{t('sidebar.order_history', 'Historique des Commandes')}</button>}
          {hasPermission('log_ajustement') && <button className="sub-item" onClick={() => smartNavigate('/logistique/ajustements')}>{t('sidebar.stock_adjustments', 'Régularisation du Stock')}</button>}
          {hasPermission('log_historique_ajustement') && <button className="sub-item" onClick={() => smartNavigate('/logistique/historique-ajustements')}>{t('sidebar.stock_adjustments_history', 'Historique des Régularisations')}</button>}
          {hasPermission('log_suppliers_dettes') && <button className="sub-item" onClick={() => smartNavigate('/logistique/dettes-fournisseurs')}>{t('sidebar.supplier_debts', 'Suivi Dettes Fournisseurs')}</button>}
          <hr style={{ border: '0.1px solid #334155', margin: '4px 0' }} />
        </NavDropdown>
      )}

      {canAccessModule('GESTOCK') && hasAnyPermission(['art_view', 'art_create', 'art_list', 'art_categories', 'art_edit', 'art_gl', 'art_tables', 'caisse_methodes']) && (
        <NavDropdown id="access_articles" label={t('sidebar.article_manager', 'Gestion Articles')} icon={Package} openMenus={openMenus} toggleMenu={toggleMenu}>
          {hasPermission('art_categories') && <button className="sub-item" onClick={() => smartNavigate('/articles/categories')}>{t('sidebar.categories_groups', 'Familles Catégories & Groupes')}</button>}
          {hasPermission('art_create') && <button className="sub-item" onClick={() => smartNavigate('/articles/create')}>{t('sidebar.add_article', 'Ajouter un Article')}</button>}
          {hasPermission('art_mod', 'GESTOCK') && <button className="sub-item" onClick={() => smartNavigate('/articles')}>{t('sidebar.mod_article', 'Modifier un Article')}</button>}

          {hasPermission('art_list') && <button className="sub-item" onClick={() => smartNavigate('/articles/list')}>{t('sidebar.articles_list', 'Liste des Articles')}</button>}
          {hasPermission('art_view') && <button className="sub-item" onClick={() => smartNavigate('/articles/unites')}>{t('sidebar.add_packaging', 'Ajouter Conditionnement')}</button>}
          {hasPermission('art_gl') && <button className="sub-item" onClick={() => smartNavigate(`/articles/history`)}>{t('sidebar.article_ledger', 'Grand livre Article')}</button>}
          {hasPermission('art_tables') && <button className="sub-item" onClick={() => smartNavigate('/articles/tables')}>{t('sidebar.tables_management', 'Gestion des Tables')}</button>}
          <hr style={{ border: '0.1px solid #334155', margin: '4px 0' }} />
        </NavDropdown>
      )}

      {canAccessModule('EMBALLAGE') && hasAnyPermission(['emb_create', 'emb_achat', 'emb_regles', 'emb_consignation', 'emb_history', 'emb_inventory_suivi', 'emb_inventory_saisie']) && (
        <NavDropdown id="access_emballages" label={t('sidebar.emballage_manager', 'Gestion des Emballages')} icon={Layers} openMenus={openMenus} toggleMenu={toggleMenu}>
          {hasPermission('emb_create') && <button className="sub-item" onClick={() => smartNavigate('/emballage/create')}>{t('sidebar.add_emballage', 'Création Emballage')}</button>}
          {hasPermission('emb_achat') && <button className="sub-item" onClick={() => smartNavigate('/emballage/achat')}>{t('sidebar.emballage_Achat', 'Achat Emballages')}</button>}
          {hasPermission('emb_regles') && <button className="sub-item" onClick={() => smartNavigate('/emballage/regles-consignation')}>{t('sidebar.regles_consignation', 'Configuration des Flux')}</button>}
          {hasPermission('emb_consignation') && <button className="sub-item" onClick={() => smartNavigate('/emballages/consignation')}>{t('sidebar.emballage_consignation', 'Consignation Emballages')}</button>}
          {hasPermission('emb_history') && <button className="sub-item" onClick={() => smartNavigate('/emballage/historique-flux-emballage')}>{t('sidebar.Embalage_flux_historique', 'Historique des inventaires')}</button>}
          {hasPermission('emb_inventory_suivi') && <button className="sub-item" onClick={() => smartNavigate('/emballages/suivi')}>{t('sidebar.emballage_inventory_suivi', 'Suivi & Lancement Inv.')}</button>}
          {hasPermission('emb_inventory_saisie') && <button className="sub-item" onClick={() => smartNavigate('/emballages/inventaire/saisie')}>{t('sidebar.emballage_inventory_saisie', 'Saisie Inv. Emballages')}</button>}
          <hr style={{ border: '0.1px solid #334155', margin: '4px 0' }} />
        </NavDropdown>
      )}

      {canAccessModule('SYSTEM') && hasAnyPermission(['user_create', 'staff_manage']) && (
        <NavDropdown id="rh_management" label={t('sidebar.user_management', 'Gestion Utilisateurs')} icon={Users} openMenus={openMenus} toggleMenu={toggleMenu}>
          {hasPermission('user_create') && (<button className="sub-item" onClick={() => smartNavigate('/users')}>{t('sidebar.user_accounts', 'Comptes Utilisateurs')}</button>)}
          {hasPermission('staff_manage') && (<button className="sub-item" onClick={() => smartNavigate('/staff')}>{t('sidebar.staff_management', 'Gestion Staff')}</button>)}
          <hr style={{ border: '0.1px solid #334155', margin: '4px 0' }} />
        </NavDropdown>
      )}

      {canAccessModule('SYSTEM') && hasAnyPermission(['tiers_fournisseur', 'tiers_client']) && (
        <NavDropdown id="tiers" label={t('sidebar.tiers', 'Gestion des Tiers')} icon={Wallet} openMenus={openMenus} toggleMenu={toggleMenu}>
          {hasPermission('tiers_fournisseur') && <button className="sub-item" onClick={() => smartNavigate('/Tiers/fournisseurs')}>{t('sidebar.tiers_fournisseur', 'Enregistrer un Fournisseur')}</button>}
          {hasPermission('tiers_client') && <button className="sub-item" onClick={() => smartNavigate('/Tiers/clients')}>{t('sidebar.tiers_client', 'Enregistrer un Client')}</button>}
          <hr style={{ border: '0.1px solid #334155', margin: '4px 0' }} />
        </NavDropdown>
      )}

      {/* RAPPORTS MANAGER */}
      {canAccessModule('SYSTEM') && hasAnyPermission(['rapports_ca', 'rapports_encaissement', 'rapports_night_audit']) && (
        <NavDropdown id="rapports_manager" label="Rapports Manager" icon={BarChart3} openMenus={openMenus} toggleMenu={toggleMenu}>
          {hasPermission('rapports_ca') && <button className="sub-item" onClick={() => smartNavigate('/rapports/ca')}>Rapport CA</button>}
          {hasPermission('rapports_encaissement') && <button className="sub-item" onClick={() => smartNavigate('/rapports/encaissements')}>Rapport Encaissement</button>}
          {hasPermission('rapports_night_audit') && <button className="sub-item" onClick={() => smartNavigate('/rapports/night-audit')}>Rapport Night Audit</button>}
          <hr style={{ border: '0.1px solid #334155', margin: '4px 0' }} />
        </NavDropdown>
      )}

      {canAccessModule('COMPTA_BASE') && hasAnyPermission([
        'compta_ex', 'compta_jr', 'compta_plan', 'analytique_plan', 'compta_tiers', 
        'compta_ecritures_auto', 'compta_brouillon', 'compta_val', 'compta_gen', 
        'compta_treso_ventilation', 'compta_cloture', 'compta_treso_saisie_hub', 
        'compta_treso_val', 'compta_brouillard_config', 'compta_treso_cash', 
        'rpt_bal_comptes', 'rpt_bal_tiers', 'compta_rpt_bal_agee', 'compta_rpt_bal_ana', 
        'compta_rpt_gl_comptes', 'compta_rpt_gl_tiers', 'compta_rpt_gl_ana', 
        'compta_rpt_bilan', 'rpt_resultat', 'rpt_tft', 'compta_etats_recap', 'compta_rpt_central'
      ]) && (
        <NavDropdown id="compta" label={t('sidebar.accounting', 'Gestion Comptable')} icon={Wallet} openMenus={openMenus} toggleMenu={toggleMenu}>
          {hasAnyPermission(['compta_ex', 'compta_jr', 'compta_plan', 'analytique_plan', 'compta_tiers', 'compta_ecritures_auto', 'compta_brouillon', 'compta_val', 'compta_gen', 'compta_treso_ventilation', 'compta_cloture']) && (
            <NavDropdown id="compta_gen_group" label={t('sidebar.general_accounting', 'Comptabilité Générale')} level={1} openMenus={openMenus} toggleMenu={toggleMenu}>
              <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px', padding: '10px 15px' }}>
                {hasPermission('compta_ex') && (<button className="sub-item" onClick={() => smartNavigate('/compta/exercices')}>{t('sidebar.fiscal_years', 'Exercices Comptables')}</button>)}
                {hasPermission('compta_jr') && (<button className="sub-item" onClick={() => smartNavigate('/compta/journaux')}>{t('sidebar.journal_codes', 'Codes Journaux')}</button>)}
                {hasPermission('compta_plan') && (<button className="sub-item" onClick={() => smartNavigate('/compta/plan')}>{t('sidebar.chart_of_accounts_btn', 'Plan comptable')}</button>)}
                {hasPermission('analytique_plan') && (<button className="sub-item" onClick={() => smartNavigate('/compta/Analytique')}>{t('sidebar.analytic_plan_btn', 'Plan Analytique')}</button>)}
                {hasPermission('analytique_plan') && (<button className="sub-item" onClick={() => smartNavigate('/compta/repartitions/config')}>{t('sidebar.analytic_config', 'Config Analytique')}</button>)}
                {hasPermission('compta_tiers') && (<button className="sub-item" onClick={() => smartNavigate('/compta/tiers')}>{t('sidebar.third_party_plan', 'Plan des Tiers')}</button>)}
                {hasPermission('compta_ecritures_auto') && (<button className="sub-item" onClick={() => smartNavigate('/compta/config-ecritures-auto')}>{t('sidebar.auto_entries_settings', 'Paramètres Écritures Auto')}</button>)}
              </div>
              <hr style={{ border: '0.1px solid #334155', margin: '4px 0', opacity: 0.3 }} />
              <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px', padding: '10px 15px' }}>
                {hasPermission('compta_brouillon') && (<button className="sub-item" onClick={() => smartNavigate('/compta/brouillon-selection')}>{t('sidebar.assistant_entry_btn', 'Saisie Assistant')}</button>)}
                {hasPermission('compta_val') && (<button className="sub-item" onClick={() => smartNavigate('/compta/validation')}>{t('sidebar.drafts_validation', 'Validation Brouillons')}</button>)}
                {hasPermission('compta_gen') && (<button className="sub-item" onClick={() => smartNavigate('/compta/gen')}>{t('sidebar.daily_entry_btn', 'Saisie Journalière')}</button>)}
                {hasPermission('compta_treso_ventilation') && (<button className="sub-item" onClick={() => smartNavigate('/compta/treso/ventilation')}>{t('sidebar.ledger_ventilation', 'Ventilation du Brouillard')}</button>)}
                {hasPermission('compta_cloture') && (<button className="sub-item" onClick={() => smartNavigate('/compta/cloture-journaliere')}>{t('sidebar.daily_closing_btn', 'Clôture Journalière')}</button>)}
              </div>
            </NavDropdown>
          )}

          {hasAnyPermission(['compta_treso_saisie_hub', 'compta_treso_val', 'compta_brouillard_config', 'compta_treso_cash']) && (
            <NavDropdown id="tresorerie_group" label={t('sidebar.treasury', 'Trésorerie')} level={1} openMenus={openMenus} toggleMenu={toggleMenu}>
              <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px', padding: '10px 15px' }}>
                {hasPermission('compta_treso_saisie_hub') && (<button className="sub-item" onClick={() => smartNavigate('/compta/treso/choix-brouillard')}>{t('sidebar.cash_drafts', 'Brouillards de Saisie')}</button>)}
                {hasPermission('compta_treso_val') && (<button className="sub-item" onClick={() => smartNavigate('/compta/treso/validation')}>{t('sidebar.expense_validation', 'Valider une Dépense')}</button>)}
                {hasPermission('compta_brouillard_config') && (<button className="sub-item" onClick={() => smartNavigate('/compta/type-brouillards')}>{t('sidebar.draft_config', 'Configuration du Brouillard')}</button>)}
                {hasPermission('compta_treso_cash') && (<button className="sub-item" onClick={() => smartNavigate('/compta/caisse')}>{t('sidebar.cash_banks', 'Caisse/Banques')}</button>)}
              </div>
            </NavDropdown>
          )}   

          {hasAnyPermission(['rpt_bal_comptes', 'rpt_bal_tiers', 'compta_rpt_bal_agee', 'compta_rpt_bal_ana', 'compta_rpt_gl_comptes', 'compta_rpt_gl_tiers', 'compta_rpt_gl_ana', 'compta_rpt_bilan', 'rpt_resultat', 'rpt_tft', 'compta_etats_recap', 'compta_rpt_central']) && (
            <NavDropdown id="compta_rapports_group" label={t('sidebar.reports_statements', 'Rapports & États')} level={1} openMenus={openMenus} toggleMenu={toggleMenu}>
              <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px', padding: '10px 15px' }}>
                {hasPermission('rpt_bal_comptes') && (<button className="sub-item" onClick={() => smartNavigate('/compta/rapports/balance-comptes')}>{t('sidebar.accounts_balance', 'Balance des comptes')}</button>)}
                {hasPermission('rpt_bal_tiers') && (<button className="sub-item" onClick={() => smartNavigate('/compta/rapports/balance-tiers')}>{t('sidebar.third_party_balance_btn', 'Balance des tiers')}</button>)}
                {hasPermission('compta_rpt_bal_agee') && (<button className="sub-item" onClick={() => smartNavigate('/compta/rapports/balance-agee')}>{t('sidebar.aged_balance', 'Balance âgée')}</button>)}
                {hasPermission('compta_rpt_bal_ana') && (<button className="sub-item" onClick={() => smartNavigate('/compta/rapports/balance-analytique')}>{t('sidebar.analytic_balance', 'Balance analytique')}</button>)}
              </div>
              <hr style={{ border: '0.1px solid #334155', margin: '4px 0', opacity: 0.3 }} />
              <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px', padding: '10px 15px' }}>
                {hasPermission('compta_rpt_gl_comptes') && (<button className="sub-item" onClick={() => smartNavigate('/compta/rapports/grand-livre')}>{t('sidebar.general_ledger_btn', 'Grand livre des comptes')}</button>)}
                {hasPermission('compta_rpt_gl_tiers') && (<button className="sub-item" onClick={() => smartNavigate('/compta/rapports/grand-livre-tiers')}>{t('sidebar.third_party_ledger_btn', 'Grand livre des tiers')}</button>)}
                {hasPermission('compta_rpt_gl_ana') && (<button className="sub-item" onClick={() => smartNavigate('/compta/rapports/grand-livre-analytique')}>{t('sidebar.analytic_ledger_btn', 'Grand livre analytique')}</button>)}
                {hasPermission('compta_rpt_central') && (<button className="sub-item" onClick={() => smartNavigate('/compta/rapports/central')}>Journal Centralisateur</button>)}
              </div>
              <hr style={{ border: '0.1px solid #334155', margin: '4px 0', opacity: 0.3 }} />
              <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px', padding: '10px 15px' }}>
                {hasPermission('compta_rpt_bilan') && (<button className="sub-item" onClick={() => smartNavigate('/compta/rapports/bilan')}>{t('sidebar.balance_sheet_btn', 'Bilan')}</button>)}
                {hasPermission('rpt_resultat') && (<button className="sub-item" onClick={() => smartNavigate('/compta/rapports/resultat')}>{t('sidebar.income_statement', 'Compte de résultat')}</button>)}
                {hasPermission('rpt_tft') && (<button className="sub-item" onClick={() => smartNavigate('/compta/rapports/tft')}>{t('sidebar.cash_flow_statement', 'TFT')}</button>)}
                {hasPermission('compta_etats_recap') && (<button className="sub-item" onClick={() => smartNavigate('/compta/rapports/etats-financiers')}>{t('sidebar.financial_statements_recap', 'États Financiers (Recap)')}</button>)}
              </div>
            </NavDropdown>
          )}
          <hr style={{ border: '0.1px solid #334155', margin: '4px 0' }} />
        </NavDropdown>
      )}

      {canAccessModule('PRODUCTION') && hasAnyPermission(['analytique_dept', 'analytique_charges', 'analytique_mp', 'analytique_ft', 'prod_besoin', 'prod_enregistrer_commande', 'prod_magasin_verif', 'prod_pilotage', 'prod_magasin_reception', 'prod_regularisations', 'analytique_psf_hist', 'analytique_prod_hist', 'analytique_mp_categories', 'prod_magasin_hist_conso', 'analytique_mp_inventaire', 'analytique_psf_inventaire', 'prod_sur_mesure', 'prod_conso_dep', 'prod_conso_dep_hist']) && (
        <NavDropdown id="access_analytique" label={t('sidebar.analytique', 'Gestion de production')} icon={Layers} openMenus={openMenus} toggleMenu={toggleMenu}>
          {hasPermission('analytique_mp') && (<button className="sub-item" onClick={() => smartNavigate('/analytique/mp/liste')}>{t('sidebar.analytique_liste', 'Liste matière première')}</button>)}
          {hasPermission('analytique_mp_categories') && (<button className="sub-item" onClick={() => smartNavigate('/analytique/mp/categories')}>Catégories Matières Premières</button>)}
          {hasPermission('analytique_mp') && (<button className="sub-item" onClick={() => smartNavigate('/analytique/mp/achat')}>{t('sidebar.analytique_achat', 'Achat MP')}</button>)}
          {hasPermission('analytique_mp') && (<button className="sub-item" onClick={() => smartNavigate('/analytique/mp/historique')}>{t('sidebar.analytique_history_achat', 'Historique Achat MP')}</button>)}
          {hasPermission('analytique_mp_inventaire') && (<button className="sub-item" onClick={() => smartNavigate('/analytique/mp/inventaire')}>Inventaire MP</button>)}
          {hasPermission('analytique_psf_hist') && (<button className="sub-item" onClick={() => smartNavigate('/analytique/psf')}>{t('sidebar.Liste_psf', 'Liste des PSF')}</button>)}
          {hasPermission('analytique_psf_inventaire') && (<button className="sub-item" onClick={() => smartNavigate('/analytique/psf/inventaire')}>Inventaire PSF</button>)}
          {hasPermission('analytique_psf_hist') && (<button className="sub-item" onClick={() => smartNavigate('/analytique/psf/historique')}>{t('sidebar.psf_history', 'Historique & Traçabilité')}</button>)}
          {hasPermission('analytique_ft') && (<button className="sub-item" onClick={() => smartNavigate('/analytique/ft/creation')}>{t('sidebar.psf_creation', 'Fiches Techniques')}</button>)}
          {hasPermission('prod_sur_mesure') && (<button className="sub-item" onClick={() => smartNavigate('/analytique/production/sur-mesure')}>Vente Sur-Mesure</button>)}
          {hasPermission('prod_conso_dep') && (<button className="sub-item" onClick={() => smartNavigate('/analytique/production/consommation-departement')}>Consommation Directe</button>)}
          {hasPermission('prod_conso_dep_hist') && (<button className="sub-item" onClick={() => smartNavigate('/analytique/production/consommation-departement-historique')}>Historique Conso. Départements</button>)}
          {hasPermission('prod_besoin') && (<button className="sub-item" onClick={() => smartNavigate('/analytique/production/besoin')}>Émettre un Besoin</button>)}
          {hasPermission('prod_enregistrer_commande') && (<button className="sub-item" onClick={() => smartNavigate('/analytique/production/enregistrer-commande')}>Enregistrement Commande / 1 Clic</button>)}
          {hasPermission('prod_magasin_verif') && (<button className="sub-item" onClick={() => smartNavigate('/analytique/production/magasin')}>Vérification Stock</button>)}
          {hasPermission('prod_magasin_reception') && (<button className="sub-item" onClick={() => smartNavigate('/analytique/production/reception')}>Magasinage & Réception</button>)}
          {hasPermission('prod_pilotage') && (<button className="sub-item" onClick={() => smartNavigate('/analytique/production/pilotage')}>Pilotage & Lancements</button>)}
          {hasPermission('prod_regularisations') && (<button className="sub-item" onClick={() => smartNavigate('/analytique/production/regularisations-attente')}>Régul. Stocks Attente</button>)}
          {hasPermission('prod_magasin_hist_conso') && (<button className="sub-item" onClick={() => smartNavigate('/analytique/production/historique-consommations')}>Historique des Consommations</button>)}
          <hr style={{ border: '0.1px solid #334155', margin: '4px 0' }} />
        </NavDropdown>
      )}
    </nav>

    <div className="sidebar-footer">
      <button 
        className="logout-button" 
        type="button"
        onClick={() => {
          localStorage.clear(); 
          sessionStorage.clear(); 
          API.post('/auth/logout').catch(() => {});
          window.location.hash = '#/welcome'; 
          window.location.reload(); 
        }}
      >
        <div className="logout-icon-wrapper"><LogOut size={18} /></div>
        <span>{t('sidebar.logout', 'Fermer la session')}</span>
      </button>
    </div>
  </aside>

  <main className="main-area">
    <header className="top-bar">
      <div className="top-bar-left-zone">
        <div className="search-container">
          <div className="search-input-wrapper">
            <Search size={18} className="search-icon" />
            <input 
              type="text" 
              placeholder={t('dashboard.topbar.search_placeholder', 'Recherche rapide...')} 
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onFocus={() => setIsSearchFocused(true)}
              onBlur={() => setTimeout(() => setIsSearchFocused(false), 250)}
              className="search-field"
            />
          </div>

          {isSearchFocused && searchTerm.length > 0 && (
            <div className="search-results-overlay">
              {searchResults.length > 0 ? (
                searchResults.map((result) => (
                  <div 
                    key={result.id}
                    onMouseDown={(e) => {
                      e.preventDefault();
                      smartNavigate(result.path);
                      setSearchTerm("");
                      setIsSearchFocused(false);
                    }}
                    className="search-result-row"
                  >
                    <div className={`icon-c ${result.color}`}>{result.icon}</div>
                    <span className="search-result-label">{result.label}</span>
                  </div>
                ))
              ) : (
                <div className="search-no-results">{t('dashboard.topbar.no_results', 'Aucun résultat')}</div>
              )}
            </div>
          )}
        </div>

        <div className="top-bar-localization-controls-3d">
          <div className="dropdown-control-wrapper-3d">
            <Languages size={14} className="control-icon-3d" />
            <select value={i18nInstance.language ? i18nInstance.language.substring(0, 2) : 'fr'} onChange={(e) => switchLanguage(e.target.value)}>
              <option value="fr">FR</option>
              <option value="en">EN</option>
            </select>
          </div>

          <div className="dropdown-control-wrapper-3d">
            <Coins size={14} className="control-icon-3d" />
            <select value={currency} onChange={(e) => switchCurrency(e.target.value)}>
              <option value="XOF">XOF</option>
              <option value="USD">USD</option>
              <option value="EUR">EUR</option>
              <option value="GNF">GNF</option>
            </select>
          </div>
        </div>
      </div>
        
      <div className="top-bar-actions-3d">
        <div className="branch-selector-3d">
          <MapPin size={16} className="control-icon-3d" />
          <select value={selectedBranchId} onChange={(e) => setSelectedBranchId(e.target.value)}>
            {isAdmin && <option value="all">Vue Globale</option>}
            {branches.map((b) => (
              <option key={b.id || b._id} value={b.id || b._id}>{b.name || b.nom}</option>
            ))}
          </select>
        </div>

        <button className="icon-btn-top-3d"><Bell size={20} /></button>

        <div className="user-profile-3d">
          <div className="user-info-3d">
            <span className="user-name-3d">{user.username || 'Utilisateur'}</span>
            <span className="user-role-3d">{isAdmin ? t('dashboard.topbar.role_admin', 'Super Administrateur') : (user.fonction || t('dashboard.topbar.role_staff', 'Collaborateur'))}</span>
          </div>
          <div className="avatar-circle-3d"><UserCircle size={28} /></div>
        </div>
      </div>
    </header>

    <div className="content-scroll">
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <h1>{t('dashboard.page.title', 'Tableau de Bord')}</h1>
          <p>{t('dashboard.page.subtitle', 'Espace de Gestion Professionnelle')} - {companyName}</p>
        </div>

        <button 
          onClick={() => setShowStats(!showStats)}
          style={{
            display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 12px',
            borderRadius: '6px', border: '1px solid var(--border-color)',
            backgroundColor: 'var(--bg-card)', color: 'var(--text-main)', cursor: 'pointer'
          }}
        >
          {showStats ? <EyeOff size={16} /> : <Eye size={16} />}
          <span style={{ fontSize: '13px' }}>{showStats ? t('dashboard.page.hide', 'Masquer') : t('dashboard.page.show', 'Afficher')}</span>
        </button>
      </div>

      <section className="stats-grid-3d">
        {canAccessModule('GESTOCK') && hasPermission('dashboard_view_products') && (
          <div className="stat-card-3d">
            <div className="stat-icon-wrapper blue-icon"><Package size={20} /></div>
            <div className="stat-content">
              <span className="stat-label-3d">{t('dashboard.stats.products', 'Produits')}</span>
              <span className="stat-value-3d">{showStats ? stats.totalProducts : "••••••"}</span>
            </div>
          </div>
        )}

        {canAccessModule('GESTOCK') && hasPermission('dashboard_view_alerts') && (
          <div className="stat-card-3d">
            <div className="stat-icon-wrapper red-icon"><Activity size={20} /></div>
            <div className="stat-content">
              <span className="stat-label-3d">{t('dashboard.stats.alerts', 'Alertes Stock')}</span>
              <span className="stat-value-3d-highlight red-text">{showStats ? stats.stockAlerts : "••••••"}</span>
            </div>
          </div>
        )}

        {canAccessModule('GESTOCK') && hasPermission('dashboard_view_sales_day') && (
          <div className="stat-card-3d">
            <div className="stat-icon-wrapper green-icon"><ShoppingCart size={20} /></div>
            <div className="stat-content">
              <span className="stat-label-3d">{t('dashboard.stats.sales_day', 'Ventes Jour')}</span>
              <span className="stat-value-3d">{showStats ? formatCurrency(stats.dailySales) : "••••••"}</span>
            </div>
          </div>
        )}

        {canAccessModule('GESTOCK') && hasPermission('dashboard_view_credit') && (
          <div className="stat-card-3d">
            <div className="stat-icon-wrapper orange-icon"><CreditCard size={20} /></div>
            <div className="stat-content">
              <span className="stat-label-3d">{t('dashboard.stats.returns', 'Retours / Avoirs')}</span>
              <span className="stat-value-3d">{showStats ? formatCurrency(stats.totalAvoirs) : "••••••"}</span>
            </div>
          </div>
        )}

      {canAccessModule('HEBERGEMENT') && (
          <>
            {hasPermission('dashboard_view_total_chambres') && (
              <div className="stat-card-3d">
                <div className="stat-icon-wrapper blue-icon"><Bed size={20} /></div>
                <div className="stat-content">
                  <span className="stat-label-3d">Total Chambres</span>
                  <span className="stat-value-3d">{showStats ? (stats.totalChambres || 0) : "••••••"}</span>
                </div>
              </div>
            )}

            {hasPermission('dashboard_view_chambres_dispo') && (
              <div className="stat-card-3d">
                <div className="stat-icon-wrapper green-icon"><Bed size={20} /></div>
                <div className="stat-content">
                  <span className="stat-label-3d">Chambres Disponibles</span>
                  <span className="stat-value-3d">{showStats ? (stats.chambresDisponibles || 0) : "••••••"}</span>
                </div>
              </div>
            )}

            {hasPermission('dashboard_view_chambres_occupees') && (
              <div className="stat-card-3d">
                <div className="stat-icon-wrapper orange-icon"><Bed size={20} /></div>
                <div className="stat-content">
                  <span className="stat-label-3d">Chambres Occupées</span>
                  <span className="stat-value-3d">{showStats ? (stats.chambresOccupees || 0) : "••••••"}</span>
                </div>
              </div>
            )}

            {hasPermission('dashboard_view_arrivees_prevues') && (
              <div className="stat-card-3d">
                <div className="stat-icon-wrapper blue-icon"><Calendar size={20} /></div>
                <div className="stat-content">
                  <span className="stat-label-3d">Arrivées Prévues (Auj.)</span>
                  <span className="stat-value-3d">{showStats ? (stats.arriveesPrevues || 0) : "••••••"}</span>
                </div>
              </div>
            )}

            {hasPermission('dashboard_view_departs_attendus') && (
              <div className="stat-card-3d">
                <div className="stat-icon-wrapper red-icon"><Calendar size={20} /></div>
                <div className="stat-content">
                  <span className="stat-label-3d">Départs Attendus (Auj.)</span>
                  <span className="stat-value-3d">{showStats ? (stats.departsAttendus || 0) : "••••••"}</span>
                </div>
              </div>
            )}
          </>
        )}
      </section>

      <section className="quick-actions" style={{ marginTop: '30px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h2 className="section-title" style={{ fontSize: '1.1rem', fontWeight: '600', color: 'var(--text-main)', margin: 0 }}>
            {t('dashboard.shortcuts.title', 'Mes Raccourcis')}
          </h2>
           
          <div style={{ display: 'flex', gap: '10px' }}>
            {isEditingShortcuts && (
              <button 
                onClick={() => setIsEditingShortcuts(false)}
                className="btn-cancel"
                style={{ 
                  padding: '8px 16px', borderRadius: '8px', border: '1px solid var(--border-color)',
                  backgroundColor: '#ffffff', color: 'var(--text-secondary)', fontSize: '13px',
                  fontWeight: '500', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px',
                  boxShadow: '3px 3px 8px rgba(163, 177, 198, 0.15)'
                }}
              >
                ✖️ {t('dashboard.shortcuts.cancel', 'Annuler')}
              </button>
            )}
            <button 
              onClick={isEditingShortcuts ? handleSaveShortcuts : () => setIsEditingShortcuts(true)}
              className="btn-modifier"
              style={{ 
                padding: '8px 16px', borderRadius: '8px', border: 'none',
                backgroundColor: isEditingShortcuts ? '#4318ff' : '#ffffff', 
                color: isEditingShortcuts ? '#fff' : '#1e293b', fontSize: '13px',
                fontWeight: '600', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px',
                transition: 'all 0.2s ease',
                boxShadow: isEditingShortcuts ? '0 4px 14px rgba(67, 24, 255, 0.4)' : '3px 3px 8px rgba(163, 177, 198, 0.2)'
              }}
            >
              {isEditingShortcuts ? t('dashboard.shortcuts.save', '💾 Enregistrer') : t('dashboard.shortcuts.configure', '⚙️ Configurer')}
            </button>
          </div>
        </div>

        <div className="quick-grid" style={{ 
          display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))', gap: '15px',
          padding: isEditingShortcuts ? '15px' : '0', backgroundColor: isEditingShortcuts ? 'rgba(163, 177, 198, 0.05)' : 'transparent',
          borderRadius: '16px', border: isEditingShortcuts ? '1px dashed rgba(163, 177, 198, 0.4)' : 'none'
        }}>
          {isEditingShortcuts ? (
            ALL_POSSIBLE_SHORTCUTS
              .filter(a => canAccessModule(a.module) && hasPermission(a.id)) 
              .map(action => {
                const isActive = myShortcuts.includes(action.id);
                return (
                  <div 
                    key={action.id} 
                    className={`action-tile ${isActive ? 'active' : ''}`}
                    onClick={() => {
                      setMyShortcuts(prev => 
                        isActive ? prev.filter(id => id !== action.id) : [...prev, action.id]
                      );
                    }}
                    style={{ 
                      position: 'relative', cursor: 'pointer', 
                      border: isActive ? '2px solid #4318ff' : '1px solid rgba(0, 0, 0, 0.03)',
                      backgroundColor: '#ffffff', opacity: isActive ? 1 : 0.5, 
                      padding: '15px', borderRadius: '14px', textAlign: 'center', transition: 'all 0.2s ease',
                      boxShadow: isActive ? '0 10px 20px rgba(67, 24, 255, 0.12)' : '4px 4px 10px rgba(163, 177, 198, 0.2), -4px -4px 10px rgba(255, 255, 255, 0.8)'
                    }}
                  >
                    {isActive && (
                      <div style={{ 
                        position: 'absolute', top: '-8px', right: '-8px', background: '#4318ff', 
                        color: 'white', borderRadius: '50%', width: '20px', height: '20px', 
                        fontSize: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                        boxShadow: '0 0 8px rgba(67, 24, 255, 0.6)', fontWeight: '800', zIndex: 2 
                      }}>✓</div>
                    )}
                    <div className={`icon-c ${action.color}`} style={{ margin: '0 auto 8px' }}>{action.icon}</div>
                    <span style={{ fontSize: '12.5px', fontWeight: '600', color: '#1e293b' }}>
                      {t(`dashboard.shortcuts.${action.id}`, action.label)}
                    </span>
                  </div>
                );
              })
          ) : (
            ALL_POSSIBLE_SHORTCUTS
              .filter(a => myShortcuts.includes(a.id) && canAccessModule(a.module) && hasPermission(a.id))
              .map(action => (
                <div 
                  key={action.id} 
                  className="action-tile" 
                  onClick={() => smartNavigate(action.path)}
                  style={{
                    padding: '20px', backgroundColor: '#ffffff', borderRadius: '16px',
                    boxShadow: '6px 6px 16px rgba(163, 177, 198, 0.35), -6px -6px 16px rgba(255, 255, 255, 0.8)',
                    textAlign: 'center', cursor: 'pointer', border: '1px solid rgba(0, 0, 0, 0.02)', transition: 'all 0.2s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-3px)';
                    e.currentTarget.style.boxShadow = '8px 8px 20px rgba(163, 177, 198, 0.45), -8px -8px 20px rgba(255, 255, 255, 0.9)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '6px 6px 16px rgba(163, 177, 198, 0.35), -6px -6px 16px rgba(255, 255, 255, 0.8)';
                  }}
                >
                  <div className={`icon-c ${action.color}`} style={{ margin: '0 auto 10px' }}>{action.icon}</div>
                  <span style={{ fontSize: '13px', fontWeight: '600', color: '#1e293b' }}>
                    {t(`dashboard.shortcuts.${action.id}`, action.label)}
                  </span>
                </div>
              ))
          )}
        </div>
      </section>
    </div>
  </main>
</div>
);
};

export default Dashboard;